import React from "react";
import InfoBox from "../../components/shared/InfoBox";
import { getContentByVariationType } from "../../content/ContentDoneSimply";
import Store from "../../content/Store";
import warningStyles from "../../assets/css/modules/features/popup-blocker-warning.css";

export const PopupBlockerWarning = ({ contentVariationType = "Any" }) => {
  const popupBlockerContent = getContentByVariationType(
    contentVariationType,
    Store.popupBlockerContent
  );

  return (
    <InfoBox
      data-popup-blocker-warning
      iconClass="icon-functional-help"
      className={"my-4 alert-warning " + warningStyles.popupWarningMessage}
    >
      {popupBlockerContent.warningMessage}
    </InfoBox>
  );
};
